import { fmtKm, fmtUnixDate } from "./wholesale-format";

export type ShareMessageInput = {
  number: string;
  partnerName: string;
  total: number;
  /** Unix SEKUNDE, kao i ostali datumi veleprodaje; `null` kad narudžba još nije potvrđena. */
  dueAt: number | null;
  url: string;
};

/**
 * Tekst poruke koja ide u Viber ili email. Redovi bez podatka se izostavljaju, a ne
 * pišu prazni — poruka se zalijepi u chat i mora se čitati kao da ju je čovjek pisao.
 */
export function buildShareMessage(input: ShareMessageInput): string {
  return [
    `Predračun ${input.number}`,
    input.partnerName,
    `Iznos: ${fmtKm(input.total)}`,
    input.dueAt ? `Rok plaćanja: ${fmtUnixDate(input.dueAt)}` : null,
    input.url,
  ]
    .filter((line): line is string => Boolean(line && line.trim()))
    .join("\n");
}

/**
 * Viber deeplink za prosljeđivanje poruke. Otvara biranje kontakta u Viber klijentu;
 * ako Viber nije instaliran, ništa se ne desi — zato dugme "Kopiraj" uvijek stoji uz njega.
 */
export function viberForwardUrl(message: string): string {
  return `viber://forward?text=${encodeURIComponent(message)}`;
}

/** `mailto:` sa istim tekstom; adresa može biti prazna kad partner nema email. */
export function mailtoUrl(email: string, number: string, message: string): string {
  const params = new URLSearchParams({ subject: `Predračun ${number}`, body: message });
  return `mailto:${encodeURIComponent(email.trim())}?${params.toString()}`;
}
